import React from 'react';
import {connect} from "react-redux";
import axios from 'axios'
import { snakeCase } from 'lodash';
import {Field, Control, Label} from "./Input";
import api from '../../../store/api'



class FileUploadInput extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            error: " ",
            uploadSuccess: false,
            dragging: false,
            hovering: false,
            progress: 0,
            file: {},
            fileName: null,
            percentLoaded: 0
        }

        this.dragCounter = 0;
    }



    handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }

    handleDragIn = (e) => {
        e.preventDefault()
        e.stopPropagation()

        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({dragging: true});
        }
    }

    handleDragOut = (e) => {
        e.preventDefault()
        e.stopPropagation()

        this.dragCounter--;
        if (this.dragCounter > 0) return;
        this.setState({dragging: false});
    }

    handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({dragging: false})

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.handleFileAssignment(e.dataTransfer.files[0])
            e.dataTransfer.clearData()
            this.dragCounter = 0
        }
    }


    getS3SignedUrl = (filename, label) => {
        const params = {filename, label, method: 'PUT'}
        if (this.props.public) params.public = true;
        return api.get('/presigned-media-url/', params)
    }


    getBase64(file) {

        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                resolve(reader.result)
            };
            reader.onerror = (error) => {
                reject('Error: ', error);
            };
        })
    }


    handleInputFileChange = (event) => {
        const file = event.target.files[0]; // accesing file
        this.handleFileAssignment(file);
    }


    handleFileAssignment = (file) => {
        this.setState({percentLoaded:0, fileName: file.name});
        let fileUploadUrl; let key; let bucket;
        
        this.getS3SignedUrl(file.name, snakeCase(this.props.description || (this.props.label || '').replace('*', '')))
            .then((res) => {
                const formData = new FormData();
                let {fields} = res.data;
                key = res.data.key;
                bucket = res.data.bucket;
                fileUploadUrl = res.data.url + '/'  + res.data.key;
                Object.keys(fields).forEach(field => {
                    formData.append(field, fields[field])
                })

                // now we are ready to append the file, but we have to rename it to match the key the server sent back
                const renamedFile = new File([file], key);
                formData.append('file', renamedFile)

                this.setState({file: {
                    ...file,
                    key,
                    bucket,
                    fileUploadUrl
                }})

                return axios.post(res.data.url, formData,  {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: progressEvent => this.setState({percentLoaded: Math.round((progressEvent.loaded / this.state.file.size) * 100)})
                })
                }).then((response) => {
                    return api.post('user-files/', {
                        key,
                        bucket,
                        datakey: this.props.dataKey,
                        user: this.props.user_id,
                        description: this.props.description || (this.props.label || '').replace('*', ''),
                        ...this.props.userFileData,
                    })
                })
                .then(() => {
                    this.setState({uploadSuccess: true, percentLoaded: 0, error: null})
                    if (this.props.onUploadSuccess) this.props.onUploadSuccess(this.state.file)
                })
                .catch((error) =>  {
                    console.error(error)
                    this.setState({error: 'The file failed to upload. Files must be less than 8MB.', percentLoaded: 0})
                })
    }


    markUploadProgress = () => {}

    onMouseEnterInput = (ev) => {
        this.setState({hovering: true})
    }

    onMouseLeaveInput = () => {
        this.setState({hovering: false})
    }

    getFileNameDisplay = () => {
        if (this.state.hovering) {
            return (
                <span className="file-name has-text-grey">
                    Drag a file here or click to select one
                </span>
            )
        } 
        if (this.props.public && this.state.fileUploadUrl) {
            return (
                <span className="file-name">{this.state.fileUploadUrl}</span>
            )
        }
        if (this.state.fileName) {
            return (
                <span className="file-name">{this.state.fileName}</span>
            )
        }  if (this.props.value) {
            return (
                <span className="file-name">{this.props.value}</span>
            )
        } 
            return (
                <span className="file-name has-text-grey">{this.props.placeholder || "Choose a file..." }</span>
            )
        
        
        
    }


    /*
    * We can use the link attribute to mark this as uploaded
    * */
    render() {
        return (
            <>
                <Label {...this.props}/>
                <div className={`field file-field 
                                ${(this.state.uploadSuccess || this.props.link) ? 'upload-success' : ''}
                                ${this.state.hovering ? 'hovering' : ''}
                                ${this.state.dragging ? 'dragging' : ''}
                                `}
                     onDragEnter={this.handleDragIn}
                     onDragLeave={this.handleDragOut}
                     onDragOver={this.handleDrag}
                     onDrop={this.handleDrop}
                >
                    {/* drop mat */}
                    <div className={`file-field__drop-mat  ${this.state.dragging ? 'dragging' : ''}`}><span>Drop!</span></div>
                    <div className="file-field__upload-bar" style={{width: `${this.state.percentLoaded}%`}}/>
                    {/* input */}
                    <div className="file has-name" onMouseEnter={this.onMouseEnterInput} onMouseLeave={this.onMouseLeaveInput}>
                        <label className="file-label">
                            <input className={`file-input ${this.props.inputClasses}`} type="file" name="resume" onChange={this.handleInputFileChange}/>
                            <span className={`file-cta ${this.state.hovering ? 'hovering' : ''}`}>
                                <span className="file-icon">
                                    {(this.state.uploadSuccess || this.props.link) && this.state.percentLoaded === 0 ?
                                        <i className="fas fa-check-circle "/> :
                                        <i className="fas fa-upload"/>}
                                </span>
                            </span>
                            {this.getFileNameDisplay()}
                        </label>
                    </div>
                    {!!this.props.addOns && this.props.addOns}
                    {/* {!!(this.props.error || this.state.error) && */}
                        <p className="help is-danger">{this.props.errMsg || this.state.error}</p>
                    {/* } */}
                </div>
            </>
    )
    }


}


const mapStateToProps = state => ({
    user_id: state.user?.decodedTokenData?.user_data?.id,
})


export default connect(mapStateToProps)(FileUploadInput)